import { render } from "./headerCom.vue?vue&type=template&id=134c576c"
import script from "./headerCom.vue?vue&type=script&lang=js"
export * from "./headerCom.vue?vue&type=script&lang=js"

import "./headerCom.vue?vue&type=style&index=0&id=134c576c&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__